// extracted by mini-css-extract-plugin
export default {"sectionTitle":"MapSettings_sectionTitle__YeyD+","clusterZoomLvl":"MapSettings_clusterZoomLvl__uQeZ+","pinIconContainer":"MapSettings_pinIconContainer__Y27o4"};